import { forwardRef } from 'react'
import { Turnstile } from '@marsidev/react-turnstile'
import { TURNSTILE_SITE_KEY } from '@/services/siteEmailService'

// Cloudflare Turnstile widget for the public marketing forms (homepage email
// capture, /contact). Renders the "managed" widget, which stays invisible for
// low-risk traffic and only shows a challenge when needed.
//
// Tokens are single-use: after a failed submit, call `reset()` on the ref and
// clear the stored token so the visitor can retry without a stale one.
//
// Renders nothing when no site key is configured — see isTurnstileConfigured
// in siteEmailService.js for what callers should do about that.
const TurnstileField = forwardRef(function TurnstileField(
  { onToken, theme = 'light', className = '' },
  ref
) {
  if (!TURNSTILE_SITE_KEY) return null

  return (
    <div className={`flex justify-center ${className}`}>
      <Turnstile
        ref={ref}
        siteKey={TURNSTILE_SITE_KEY}
        onSuccess={onToken}
        onError={() => onToken('')}
        onExpire={() => onToken('')}
        options={{ theme }}
      />
    </div>
  )
})

export default TurnstileField
